import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidCircleIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M22 12c0 5.5-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2s10 4.5 10 10Z"/>
  </SvgIcon>
}

export default SolidCircleIcon
